import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../interfaces/IIcon";

export const PlayIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="m 2.7341626,1.4739488 c -0.037352,0.00398 -0.04137,0.00168 -0.08783,0.00645 -0.1746297,0.021439 -0.6435152,0.167217 -0.6434605,0.6143524 -0.00844,1.9366032 0.00365,3.873202 0.011467,5.8098031 4.005e-4,0.1282388 0.046653,0.2496502 0.1260181,0.348298 0.033918,0.041927 0.076314,0.074112 0.1145692,0.1112642 0.2398477,0.1911448 0.6099085,0.2286074 0.8993107,0.070949 C 4.7582,7.5536867 6.3777709,6.700853 7.9696402,5.7970358 L 8.4947157,5.5116249 C 8.6976227,5.3999407 8.8392857,5.1979329 8.8250367,4.9601454 8.8121557,4.7454073 8.6677927,4.5444379 8.4278877,4.4409313 L 7.9715494,4.1942202 C 6.3733692,3.3024448 4.7574034,2.4434795 3.1484948,1.5723108 3.0206657,1.5030917 2.8753425,1.4710876 2.7341626,1.4739488 Z" />
        </SvgIcon>
    );
};
import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../interfaces/IIcon";

export const PlayIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="m 2.7341626,1.4739488 c -0.037352,0.00398 -0.04137,0.00168 -0.08783,0.00645 -0.1746297,0.021439 -0.6435152,0.167217 -0.6434605,0.6143524 -0.00844,1.9366032 0.00365,3.873202 0.011467,5.8098031 4.005e-4,0.1282388 0.046653,0.2496502 0.1260181,0.348298 0.033918,0.041927 0.076314,0.074112 0.1145692,0.1112642 0.2398477,0.1911448 0.6099085,0.2286074 0.8993107,0.070949 C 4.7582,7.5536867 6.3777709,6.700853 7.9696402,5.7970358 L 8.4947157,5.5116249 C 8.6976227,5.3999407 8.8392857,5.1979329 8.8250367,4.9601454 8.8121557,4.7454073 8.6677927,4.5444379 8.4278877,4.4409313 L 7.9715494,4.1942202 C 6.3733692,3.3024448 4.7574034,2.4434795 3.1484948,1.5723108 3.0206657,1.5030917 2.8753425,1.4710876 2.7341626,1.4739488 Z" />
        </SvgIcon>
    );
};
